export function heroSlider() {
    const wrapper = $(".hero-section");
    const slider = wrapper.find(".slides");
    const dots = wrapper.find(".slider-dots");
    const sliderSpeed = wrapper.data("sliderSpeed") * 1000;
    const dotsColor = dots.data("color");
    const rtl = this.rtl;

    slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true, 
        arrows: false,
        appendDots: dots,
        accessibility: false,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1279,
                settings: {
                    fade: true
                }
            }
        ],
        rtl
    });

    slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        dots.find("button").blur();
    });


    dots.find("button").css("background-color", dotsColor);

    $(window).on("resize", function () {
        setTimeout(function () {
            dots.find("button").css("background-color", dotsColor);
        }, 200);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-slider.js